//#region src/components/Icon/IndicatorIcon/IndicatorIcon.module.css
var IndicatorIcon_module_default = { "indicator-icon": "_indicator-icon_147l5_17" };
//#endregion
export { IndicatorIcon_module_default as default };

//# sourceMappingURL=IndicatorIcon.module.js.map